import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserService } from '@src/core/services';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly ngxPermissionsService = inject(NgxPermissionsService);
  private readonly userService = inject(UserService);

  allowGroupChatCreating$ = new BehaviorSubject(false);
  allowPrivateChatCreating$ = new BehaviorSubject(false);

  private permissions = this.ngxPermissionsService.getPermissions();

  constructor() {
    this.userService.authUser$.subscribe(user => {
      if (!user) {
        return;
      }

      this.getPermissions();
    });
  }

  getPermissions() {
    this.allowGroupChatCreating$.next('organisationChatsEditing' in this.permissions);
    this.allowPrivateChatCreating$.next('userChatButtonViewing' in this.permissions);
  }

  isAuthUser(userId: string) {
    return this.userService.authUser$.value?.id === userId;
  }
}
